import { IconComponentsProps } from './types';

const ChevronLeftIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="16" height="16" viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z" />
  </svg>
);

export default ChevronLeftIcon;
